import React from "react";
import PropTypes from "prop-types";

const LimitationAlert = ({ totalNumber, totalAllowed }) => {
  const percentage = (totalNumber / totalAllowed) * 100;
  return (
    <div className="d-flex flex-wrap gap-2">
      <button
        type="button"
        className={`btn ${
          percentage > 90
            ? "btn-outline-danger"
            : percentage > 75
            ? "btn-outline-warning"
            : percentage > 50
            ? "btn-outline-success"
            : "btn-outline-primary"
        }  my-1 me-2`}
      >
        <span
          className={`badge ${
            percentage > 90
              ? "bg-danger"
              : percentage > 75
              ? "bg-warning"
              : percentage > 50
              ? "bg-success"
              : "bg-primary"
          }  ms-2`}
        >
          {totalNumber}
        </span>{" "}
        / {totalAllowed}
      </button>
    </div>
  );
};

export default LimitationAlert;

LimitationAlert.propTypes = {
  totalNumber: PropTypes.number.isRequired,
  totalAllowed: PropTypes.number.isRequired,
};
